import React from 'react';
import Tooltip from 'rc-tooltip';
import { TooltipProps } from 'rc-tooltip/lib/Tooltip';

export interface IPopover {
  offset?: number[];
  visible?: TooltipProps['visible'];
  overlay?: TooltipProps['overlay'];
  children: TooltipProps['children'];
  trigger: TooltipProps['trigger'];
  destroyTooltipOnHide?: TooltipProps['destroyTooltipOnHide'];
  placement?: TooltipProps['placement'];
  [key: string]: any;
}

const Popover: React.FC<IPopover> = ({
  offset = [0, 2],
  visible,
  overlay,
  children,
  trigger,
  placement,
  ...otherProps
}) => {
  let props;
  if (visible === undefined) {
    props = { ...otherProps };
  } else {
    props = { visible, ...otherProps };
  }
  return (
    <Tooltip
      align={{
        offset,
      }}
      {...props}
      overlay={overlay}
      trigger={trigger}
      placement={placement}
    >
      {children}
    </Tooltip>
  );
};

export default Popover;
